'use client';
import t from "react";
function f(n) {
  const [o, e] = t.useState(
    (n == null ? void 0 : n.isDefaultOpened) ?? !1
  ), s = t.useCallback(() => {
    e(!0);
  }, [e]), l = t.useCallback(() => {
    e(!1);
  }, [e]), u = t.useCallback(() => {
    e((c) => !c);
  }, [e]);
  return {
    isOpened: o,
    onOpen: s,
    onClose: l,
    onToggle: u,
    setIsOpened: e
  };
}
export {
  f as useDisclosure
};
